import React from "react";
import ReactPieChart from "react-minimal-pie-chart";
import PropTypes from "prop-types";
import { useTheme } from "@mui/styles";

const ChartLabel = props => {
  const { dataIndex, style, percentage, dx, dy, ...otherProps } = props;

  return (
    <text
      {...otherProps}
      fontSize={style.fontSize}
      dominantBaseline={style.dominantBaseline}
    >
      {`${percentage}%`}
    </text>
  );
};

const Gradient = () => {
  const theme = useTheme();
  return (
    <defs key={"gradient"}>
      <linearGradient id={"gradient"} x1={"0%"} y={"0%"} x2={"0%"} y2={"100%"}>
        <stop offset={"0%"} stopColor={theme.palette.primary.light} />
        <stop offset={"100%"} stopColor={theme.palette.primary.main} />
      </linearGradient>
    </defs>
  );
};

export default function PieChart(props) {
  let { percent } = props;
  const theme = useTheme();
  if (isNaN(percent)) {
    percent = 0;
  }
  return (
    <ReactPieChart
      injectSvg={() => <Gradient />}
      data={[
        {
          value: 100 - percent,
          color: theme.palette.secondary[100]
        },
        {
          value: percent,
          color: "url(#gradient)"
        }
      ]}
      label={<ChartLabel percentage={percent} />}
      labelStyle={{
        fontSize: "1rem",
        dominantBaseline: "middle"
      }}
      labelPosition={0}
      totalValue={100}
      startAngle={-90}
      lineWidth={36}
    />
  );
}

PieChart.propTypes = {
  compliancePercent: PropTypes.number
};
